var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',{staticClass:"contentproviders"},[_c('DemosComponent',{attrs:{"programs":_vm.programs,"headers":_vm.headers},on:{"itemClick":_vm.onItemClick}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }